module.exports = __webpack_public_path__ + "static/media/shortTextnumber.4c16569e.svg";